import * as base from './base.jsx';
import * as  misc from './misc.jsx';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

class PopupComponent extends base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      key: this.props.key || Math.random().toString(36).substring(7)
    });
  }

  escPressed() {
    this.props.onEsc();
  }

  getContent() {
    return
  }

  handleKeyDown(event) {
    if (event.keyCode == 27) {
      this.escPressed();
    }
  }

  componentWillMount(){
    window.addEventListener("keydown", this.handleKeyDown.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown.bind(this));
  }

  stopProp(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }

  getClassName() {
    return "popup-inside";
  }

  render() {
    var popup;
    if (this.props.showing) {
      popup = <div
        className="popup-background"
        onClick={this.escPressed.bind(this)}
        key={this.state.key}
      >
        <div className={this.getClassName()} onClick={this.stopProp.bind(this)}>
          <div className="esc-button" onClick={this.escPressed.bind(this)}>
            <i className="icon-cross"></i>
            esc
          </div>
          { this.getContent() }
        </div>
      </div>
    }
    return <CSSTransitionGroup transitionName="fade"
      transitionEnterTimeout={200} transitionLeaveTimeout={200}>
      {popup}
    </CSSTransitionGroup>
  }
}

class ConfirmPopup extends PopupComponent {
  getContent() {
    return <div>
      <div className="popup-title">
        <i className={this.props.icon} style={this.props.icon_colour ? {color: this.props.icon_colour} : {}}></i>
        {this.props.title}
      </div>
      <div className="popup-subtitle">
        {this.props.subtitle}
      </div>
      <div className="actions">
        <misc.FlatButton
          label={this.props.confirmButtonLabel || "Confirm"}
          className="green-background"
          onClick={this.props.onConfirm}
        />
        <misc.FlatButton
          label={this.props.cancelButtonLabel || "Cancel"}
          className="yellow-background"
          onClick={this.props.onCancel}
        />
      </div>
    </div>
  }
}

module.exports = {
  PopupComponent: PopupComponent,
  ConfirmPopup: ConfirmPopup
}
